module.exports = __webpack_public_path__ + "assets/img/warrior-name-0b69e59c.png";